/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Consents_SourceInputs */

const cs_clients_consents_source = /** @type {(inputs: Clients_Consents_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdroj`)
};

const en_clients_consents_source = /** @type {(inputs: Clients_Consents_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

/**
* | output |
* | --- |
* | "Source" |
*
* @param {Clients_Consents_SourceInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_consents_source = /** @type {((inputs?: Clients_Consents_SourceInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Consents_SourceInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_consents_source(inputs)
	return cs_clients_consents_source(inputs)
});